import { defineMessages } from 'react-intl';

export default defineMessages({
	backToSettings: {
		defaultMessage: 'Cancel',
		description:
			'Action label for the cancel/back button in the action bar of the help center layout builder screen',
		id: 'cv.portal.customization.action.cancel.help.center.settings',
	},
	giveFeedback: {
		defaultMessage: 'Give feedback',
		description:
			'Action label for the give feedback button in the action bar of the help center layout builder screen',
		id: 'cv.portal.customization.action.give.feedback.help.center.settings',
	},
	publish: {
		defaultMessage: 'Publish',
		description: 'Label for the publish button in the action bar of the help center layout builder',
		id: 'cv.portal.customization.action.publish.layout.label',
	},
	preview: {
		defaultMessage: 'Preview',
		description: 'Label for the preview button in the action bar of the help center layout builder',
		id: 'cv.portal.customization.action.preview.layout.label',
	},
	previewMessage: {
		defaultMessage: 'This is a preview of the changes you made to the page layout.',
		description:
			'Informational message displayed in the action bar when the user is previewing layout changes in the help center layout builder',
		id: 'cv.portal.customization.action.preview.layout.message',
	},
	exitPreview: {
		defaultMessage: 'Back',
		description:
			'Label for the back button that exits the preview mode in the help center layout builder',
		id: 'cv.portal.customization.action.exit.preview.layout.label',
	},
});
